export const MISSING_COMPARISON_VALUE = '-';
export const DEFAULT_ATTRIBUTE_LIMIT = 5;
export const ALTERNATIVE_PRODUCTS_FETCH_LIMIT = 30;
export const ALTERNATIVE_PRODUCTS_DISPLAY_LIMIT = 5;
export const DEFAULT_ATTRIBUTE_PRIORITY = 0;
